import React from 'react';
import classNames from 'classnames';
import { BulletDivider } from '../dividers';
import TimeAgo from '../time-ago/time-ago';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { AUTHOR } from '../../../common/constants/data-hooks';
import { getOwnerName } from '../../../common/store/members/members-selectors';
import { useApi } from '../../context/api-context/use-api';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { getIsMaInstalled, getIsMobile, } from '../../../common/store/base-params/base-params-selectors';
import ProfileLink from '../profile-link/profile-link';
import MemberBadgeLazy from '../member-badge/member-badge-lazy';
import MemberCardLazy from '../member-card/member-card-lazy';
import styles from './user-info.module.scss';
import { RoleBadge } from '../role-badge/role-badge';
import { renderNodesWithDivider } from '../../../common/utils/render-nodes-with-divider';
const UserInfo = ({ avatar, owner, timestamp }) => {
    const { roleIcons, roleBadges, renderAuthorRole, hideBadge, hidePublishDate } = useConfiguration();
    const { isMAInstalled, isMobile } = useApi((state) => ({
        isMAInstalled: getIsMaInstalled(state),
        isMobile: getIsMobile(state),
    }));
    const t = useTranslate();
    const [isMemberCardInvoked, showMemberCard] = React.useState(false);
    const elementRef = React.useRef(null);
    const memberBadges = owner.type === 'MEMBER' ? owner.member?.memberBadges ?? [] : [];
    const { memberRole, member } = owner.type === 'MEMBER'
        ? {
            memberRole: owner.member?.memberRoles?.[0],
            member: owner.member,
        }
        : {
            memberRole: undefined,
            member: undefined,
        };
    const RoleIcon = memberRole && roleIcons?.[memberRole];
    const roleBadge = memberRole && roleBadges?.[memberRole];
    return (React.createElement("div", { ref: elementRef, onMouseOver: () => showMemberCard(true), className: classNames(styles.root, isMobile && styles.isMobile) },
        isMAInstalled && owner.type === 'MEMBER' && isMemberCardInvoked && elementRef.current && (React.createElement(MemberCardLazy, { viewedMemberId: owner.member.id, elementRef: elementRef.current })),
        avatar ? avatar : null,
        React.createElement("div", { className: styles.content },
            React.createElement(ProfileLink, { className: styles.row, member: member },
                React.createElement("span", { className: styles.username, "data-hook": AUTHOR }, getOwnerName(owner, t)),
                renderAuthorRole ? (owner.type === 'MEMBER' ? (renderAuthorRole({ memberId: owner.member.id })) : null) : (React.createElement(React.Fragment, null,
                    RoleIcon ? (React.createElement("div", { className: styles.roleIcon },
                        React.createElement(RoleIcon, null))) : null,
                    roleBadge ? (React.createElement(RoleBadge, { className: styles.roleBadge, label: roleBadge.label })) : null))),
            React.createElement("div", { className: styles.row }, renderNodesWithDivider([
                timestamp && !hidePublishDate && (React.createElement(TimeAgo, { className: styles.time, time: timestamp, key: "time-ago" })),
                memberBadges.length > 0 &&
                    !hideBadge &&
                    memberBadges.map((badge) => (React.createElement(MemberBadgeLazy, { key: `member-badge-${badge.id}`, className: styles.badge, badge: badge, layout: "name-only" }))),
            ].filter(Boolean), React.createElement(BulletDivider, { className: styles.divider }))))));
};
export default UserInfo;
//# sourceMappingURL=user-info.js.map